import DateRangeFilter from '../../cards/FilterCard/dateRangeFilter/DateRangeFilter';
import type { DownloadDateFiltersEchoProps } from './downloadDrawer.d';
import { ShowsIcon } from '@/components/icons/ShowsIcon';
import { MultiSelectEcho } from '@/components/echo/primitives';

const DownloadDrawerFiltersEcho = ({
  showOptions,
  downloadSettings,
  setDownloadSettings,
  setDateRange,
  onDateOpen,
  onDatePresetSelect,
  onDateApply,
}: DownloadDateFiltersEchoProps) => {
  return (
    <div className="flex w-full flex-col gap-6">
      <div>
        <MultiSelectEcho
          allowClear
          disabled={!showOptions.length}
          classNames={{
            root: '!ps-3 text-sm text-textDarkGrey',
            prefix: '!ms-0 flex shrink-0 items-center self-center pr-1 text-textMedGrey',
            placeholder: '!text-textDarkGrey',
          }}
          prefix={<ShowsIcon />}
          placeholder="Shows: All"
          value={downloadSettings.shows}
          onChange={(selectedShowIds) =>
            setDownloadSettings((prev) => ({
              ...prev,
              shows: selectedShowIds,
            }))
          }
          options={showOptions}
          showSearch={{ optionFilterProp: 'label' }}
          maxTagCount="responsive"
          className="w-full"
          aria-label="download-drawer-shows-combobox"
        />
      </div>
      <div>
        <DateRangeFilter
          dateRange={{
            from: downloadSettings.dateRange.from,
            to: downloadSettings.dateRange.to,
          }}
          onOpen={onDateOpen}
          onPresetSelect={onDatePresetSelect}
          onApply={(from, to) => {
            setDateRange({ from, to });
            onDateApply(from, to);
          }}
        />
      </div>
    </div>
  );
};

export default DownloadDrawerFiltersEcho;
